<template>
  <form @submit="reportFilterSubmit" class="flex-1">
    <div class="flex items-center relative">
      <input
        type="search"
        class="form-field pr-11 pl-9"
        id="keyword"
        placeholder="Enter search query"
        v-model="query"
      />
      <div
        class="absolute bottom-0 left-2.5 flex h-11 items-center text-gray-0 text-opacity-70"
      >
        <Search :size="20" :stroke-width="1.75" />
      </div>
      <div class="absolute right-11 top-1" v-if="query">
        <button
          class="w-9 h-9 bg-primary-100 flex items-center justify-center rounded-md text-white-100"
          @click="clearFilterSubmit"
        >
          <X :size="18" :stroke-width="1.75" />
        </button>
      </div>
      <div class="absolute right-1 top-1">
        <button
          class="w-9 h-9 bg-primary-100 flex items-center justify-center rounded-md text-white-100"
          @click="reportFilterSubmit"
        >
          <Search :size="18" :stroke-width="1.75" />
        </button>
      </div>
    </div>
  </form>
</template>

<script setup lang="ts">
import { ref, watch } from "vue";
import type { Ref } from "vue";
import { useUserStore } from "../stores/user";
import { Search, X } from "lucide-vue-next";
const userStore = useUserStore();
const query: Ref<string> = ref("");
const clearFilterSubmit = () => {
  query.value = "";
  userStore.setReportSearchQuery(query.value);
};
const reportFilterSubmit = async (e: Event | null = null) => {
  e && e.preventDefault();
  userStore.setReportSearchQuery(query.value);
};
watch(query, (val) => {
  if (val === "") {
    reportFilterSubmit();
  }
});
</script>
